import { render } from "./dragFileUpload.vue?vue&type=template&id=304659f9"
import script from "./dragFileUpload.vue?vue&type=script&lang=js"
export * from "./dragFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__